import setupMovingElements from './responsive-moving-elements';

setupMovingElements(jQuery, window, document);
